import { object, string } from 'yup';

const LoginSchema = object().shape({
  email: string().email('Enter a valid email').required('Email is required'),
  password: string().min(6, 'Password must contain at least 6 characters').required('Enter your password'),
});

export default LoginSchema;
